import { useEffect } from "react";
import { announce } from "@react-aria/live-announcer";

/**
 * Announces a message to screen readers once per distinct message, through the polite
 * live region react-aria keeps mounted in the document - a region rendered together with
 * its content is not reliably announced (WCAG 4.1.3 Status Messages).
 */
const useAnnounce = (message?: string) => {
  useEffect(() => {
    if (!message) {
      return;
    }

    announce(message, "polite");
  }, [message]);
};

export default useAnnounce;
